import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { Typography } from 'interfaces/typography';
import { 
    updateCurrentDispositions,
    selectCurrentDispositions,
    selectIsSaving
} from 'lib/redux/settings/platformDispositionsSlice';

export function AddNewDisposition() {
    const dispatch = useDispatch();
    const platform = useSelector((state: RootState) => state.autodialerSettings.selectedPlatform);
    const currentDispositions = useSelector(selectCurrentDispositions(platform!));
    const isSaving = useSelector(selectIsSaving(platform!));
    const [newDisposition, setNewDisposition] = useState('');

    const handleAddDisposition = () => {
        if (platform && newDisposition.trim()) {
            const trimmed = newDisposition.trim();
            if (!currentDispositions.includes(trimmed)) {
                const newList = [...currentDispositions, trimmed];
                dispatch(updateCurrentDispositions({ platform, dispositions: newList }));
                setNewDisposition('');
            }
        }
    };

    return (
        <div className="space-y-3">
            <Typography variant="largeParagraph" fontWeight="500" color="#374151">
                Add New Disposition
            </Typography>
            <div className="flex gap-2">
                <input
                    type="text"
                    value={newDisposition}
                    onChange={(e) => setNewDisposition(e.target.value)}
                    onKeyPress={(e) => e.key === 'Enter' && handleAddDisposition()}
                    placeholder="Enter a new disposition..."
                    className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    disabled={isSaving}
                />
                <button
                    onClick={handleAddDisposition}
                    disabled={!newDisposition.trim() || isSaving}
                    className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
                >
                    <Typography variant="smallParagraph" color="white" fontWeight="500">
                        Add
                    </Typography>
                </button>
            </div>
        </div>
    );
}